import {Injectable} from '@angular/core';
import {AngularFireStorage, AngularFireUploadTask} from '@angular/fire/storage';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {finalize} from 'rxjs/operators';
import {AngularFirestore} from '@angular/fire/firestore';
import * as firebase from 'firebase';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';

declare let gapi: any;
declare let google: any;

@Injectable({
  providedIn: 'root',
})
export class UploadService implements CanActivate {
  details: any = sessionStorage.form ? JSON.parse(sessionStorage.form) : undefined;
  // apiKey = 'AIzaSyBRHpYUnc0zXzqb_k5zLYlNRGe8GvEwoNQ';
  apiKey = 'AIzaSyDu6v6TEnXftIVgYfXqSKjKIMJAusAGZM0';
  scope = ['https://www.googleapis.com/auth/drive.file'];
  clientId =
    '339399522200-71jtqg0dekfkm3fr0soqol8j9rkos2pk.apps.googleusercontent.com';
  // clientId = '997885489104-5n3g1l87et2khjeq0fmg9jbll212rlif.apps.googleusercontent.com';
  // appId = '997885489104';
  appId = '339399522200';
  driveUrl = 'https://www.googleapis.com/drive/v3/';

  pickerApiLoaded = false;
  oauthToken: any;

  downloadURL;
  task: AngularFireUploadTask;
  percentage: Observable<number>;
  file: Observable<any>;

  //timestapm to store value
  timeStamp =  firebase.firestore.FieldValue.serverTimestamp;

  constructor(
    private storage: AngularFireStorage,
    private afs: AngularFirestore,
    private http: HttpClient
  ) {}

  uploadFile(path, file, sentence: any): any {
    this.task = this.storage.upload(path, file);
    this.details.sentence = sentence;
    this.details.filename = path;
    const ref = this.storage.ref(path);
    // return this.task
    return this.task.snapshotChanges().pipe(
      finalize(async () => {
        this.downloadURL = await ref.getDownloadURL().toPromise();
        const dataRef = this.afs
          .collection('accentsdata')
          .doc(this.getUniqueID()).ref;
        // const statsRef = this.afs.collection('datapoints').doc('--stats--').ref;
        const statsRef = this.afs.collection('accentsdata').doc('--stats--')
          .ref;
        const increment = firebase.firestore.FieldValue.increment(1);
        const batch = this.afs.firestore.batch();

        //invoking timestamp
        const createdAt = this.timeStamp();
        batch.set(dataRef, {
          ageOfEnglish: this.details.form.ageOfEnglish,
          countryResidence: this.details.form.countryResidence,
          filename: file.name,
          fluentLanguage: this.details.form.fluentLanguage,
          nationality: this.details.form.nationality,
          nativeLanguage: this.details.form.nativeLanguage,
          otherLanguages: this.details.form.otherLanguages,
          sentence: sentence.id,
          userID: this.details.userID,
          audioUrl: this.downloadURL,
          createdAt
        });
        batch.set(statsRef, { count: increment }, { merge: true });
        await batch.commit();
        console.log(this.downloadURL);
      })
    );
  }

  getUniqueID(): string {
    return Math.random().toString(36).substr(2, 15);
  }

  onDriveApiLoad() {
    gapi.load('auth', { callback: this.onAuthApiLoad.bind(this) });
    gapi.load('picker', { callback: this.onPickerApiLoad.bind(this) });
  }

  onAuthApiLoad() {
    gapi.auth.authorize(
      {
        client_id: this.clientId,
        scope: this.scope,
        immediate: false,
      },
      this.handleAuthResult.bind(this)
    );
  }

  onPickerApiLoad() {
    this.pickerApiLoaded = true;
    this.createPicker();
  }

  handleAuthResult(authResult) {
    if (authResult && !authResult.error) {
      this.oauthToken = authResult.access_token;
      console.log(this.oauthToken);
      this.createPicker();
    }
  }

  createPicker() {
    if (this.pickerApiLoaded && this.oauthToken) {
      const view = new google.picker.View(google.picker.ViewId.DOCS);
      // view.setMimeTypes("image/png,image/jpeg,image/jpg,video/mp4,audio/m4a,audio/mpeg,audio/mp3,audio/wav,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,text/csv");
      const picker = new google.picker.PickerBuilder()
        .enableFeature(google.picker.Feature.NAV_HIDDEN)
        .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setAppId(this.appId)
        .setOAuthToken(this.oauthToken)
        .addView(view)
        .addView(new google.picker.DocsUploadView())
        .setDeveloperKey(this.apiKey)
        .setCallback(this.pickerCallback)
        .build();
      picker.setVisible(true);
    }
  }

  pickerCallback(data) {
    if (data.action == google.picker.Action.PICKED) {
      const fileId = data.docs[0].id;
      alert('The user selected: ' + fileId);
      this.file = data.docs[0];
      console.log(this.file);

      downloadFile(this.file);

      function downloadFile(file) {
        if (file.url) {
          const accessToken = gapi.auth.getToken().access_token;
          const xhr = new XMLHttpRequest();
          xhr.open('GET', file.url);
          xhr.setRequestHeader('Authorization', 'Bearer ' + accessToken);
          xhr.setRequestHeader('Access-Control-Allow-Origin', '*');
          xhr.responseType = 'blob';
          //    xhr.onload = function() {
          //      console.log(xhr.responseText);
          //  };
          //  xhr.onerror = function(err) {
          //    console.log(err);
          //  };
          xhr.send();
          console.log(xhr.response);
        } else {
          console.log('null');
        }
      }
    }
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.details !== undefined) {
      return true;
    } else {
      window.alert(
        "You don't have permission to view this page. Enter your details first"
      );
      return false;
    }
  }
}
